export default __webpack_public_path__ + "static/media/CMP.50266fe2.jpg";